import * as swcHelpers from '@swc/helpers';

const defaultStockLevels = [
    // Order matters! The `findStock()` method will walk through this array and stop at its first match
    {
        threshold: 10,
        labelId: 'inStock'
    },
    {
        threshold: 5,
        labelId: 'lowStock'
    },
    {
        threshold: 1,
        labelId: 'veryLowStock'
    },
    {
        threshold: 0,
        labelId: 'outOfStock'
    }, 
];
const getStockLevels = (thresholdConfig = [])=>defaultStockLevels.map((level)=>swcHelpers.objectSpread({}, level, thresholdConfig.find((threshold)=>threshold.labelId === level.labelId
        ))
    )
;
const stockResolver = (channelAvailability, allowBackOrder, stockCount, thresholdConfig)=>{
    // No negative stockCount
    const positiveStockCount = Math.max(stockCount || 0, 0);
    // If the product is only available in store, or it's out of stock with no backorder
    // allowed, show out of stock
    if (channelAvailability === 'IN_STORE_ONLY' || !positiveStockCount && !allowBackOrder) {
        return {
            threshold: 0,
            labelId: 'outOfStock'
        };
    }
    // Get stock level based on the thresholds
    const stockLevel1 = getStockLevels(thresholdConfig).find((stockLevel)=>positiveStockCount >= stockLevel.threshold
    );
    // If stock level is outOfStock according to threshold but allowBackOrder is true
    // show the backOrder label
    if ((stockLevel1 === null || stockLevel1 === void 0 ? void 0 : stockLevel1.labelId) === 'outOfStock' && allowBackOrder) {
        return {
            threshold: 0,
            labelId: 'backOrder'
        };
    }
    return stockLevel1;
};

export { defaultStockLevels, getStockLevels, stockResolver };
//# sourceMappingURL=helpers.js.map
